/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-accordion-group component
 */

// component name
$component: 'zr-accordion-group';

// component vars defaults
:host {
    display: block;
}
